import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, ArrowLeft } from 'lucide-react';

const NotFound = () => (
  <section className="pt-[180px] lg:pt-[210px] pb-32 min-h-[80vh] grid place-items-center bg-emerald-grad">
    <div className="text-center container-x">
      <div className="font-display text-[120px] lg:text-[200px] text-brand-gold leading-none">404</div>
      <h1 className="h-display text-[36px] text-brand-cream mt-4">Aradığınız sayfa bulunamadı.</h1>
      <p className="text-mute mt-3">Yanlış bir bağlantı izlemiş olabilirsiniz.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/" className="btn-gold"><HomeIcon size={14} /> Anasayfa</Link>
        <Link to="/iletisim" className="btn-outline-gold"><ArrowLeft size={14} /> İletişim</Link>
      </div>
    </div>
  </section>
);

export default NotFound;
